export const ACTIVATE = 'API_KEY/ACTIVATE'
export const CREATE = 'API_KEY/CREATE'
export const DEACTIVATE = 'API_KEY/DEACTIVATE'
export const GET_API_KEYS = 'API_KEY/GET_KEYS'
